// Single source of truth for company-wide facts used in copy.
export const FOUNDING_YEAR = 2022;
